import template from './orderAndPay.html';

const orderAndPayDetailsComponent = {
  restrict: 'E',
  template,
};

export default orderAndPayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/orderAndPay.component.js
 **/